import { Component, OnInit } from '@angular/core';
import { TILES } from '../../constants/reference.constants';
import { ActivatedRoute, Router } from '@angular/router';
import { TileItem } from '../../models/tileItem';
import { ReferenceService } from '../../services/reference.service';
import { AuthenticationService } from '../../../authentication/state/authentication.service';
import { AuthenticationHttpService } from '../../../authentication/services/authentication-http.service';
import { LogService } from '../../../core/logger/services/log.service';
import { UserService } from '../../../user/services/user.service';

@Component({
  selector: 'app-references',
  templateUrl: './references.component.html',
  styleUrls: ['./references.component.scss'],
})


export class ReferencesComponent implements OnInit {
  tiles = TILES;
  assignedTiles: any;
  loading = false;
  selectedTile!: TileItem | null;
  userOrganisations: any[] = [];
  selectedOrgName: any;
  categoryName: string | null = null;
  orgId!: number;
  allTiles: any[] = [];

  references = [
    { code: 'ISO 9001:2015', desc: 'Quality Management System Standard', route: '/QualityManagement' },
    { code: 'ISO 14001:2015', desc: 'Environmental Management System Standard', route: '/EnvironmentalManagement' },
    { code: 'ISO 45001:2018', desc: 'Occupational Health and Safety Standard', route: '/HealthSafety' }
  ];

  constructor(private router: Router, private referenceService: ReferenceService, public authenticationService: AuthenticationService,
    private authHttpService: AuthenticationHttpService,
    private logService: LogService, private route: ActivatedRoute, private userService: UserService,
  ) { }

  ngOnInit(): void {
    this.orgId = Number(localStorage.getItem('SelectedOrgId'));
    this.loadDocumentCounts();
    this.route.root.queryParams.subscribe(params => {
      this.categoryName = params['category'] || localStorage.getItem('selectedCategory');
    });
    this.getUserTiles();
    this.loadOrganisations();
    if (this.canViewAllTiles) {
      this.tiles = TILES;
      this.tiles = this.filterByCategory(this.tiles);
    } else {
      const storedTiles = sessionStorage.getItem('userTiles');
      if (storedTiles) {
        const userTiles: any[] = JSON.parse(storedTiles); // stored objects
        const userTileIds: number[] = userTiles.map(t => t.id); // extract IDs
        const filteredTiles = TILES.filter(tile => userTileIds.includes(tile.id));
        this.tiles = this.filterByCategory(filteredTiles);
      } else {
        this.tiles = [];
      }
    }
  }

  loadDocumentCounts() {
  if (!this.orgId) return;

  this.referenceService.getDocumentsCountByCategory(this.orgId).subscribe({
    next: (apiCounts: any) => {

      const filteredCounts = apiCounts.filter((item: any) => {
        if (
          item.stateName === "SubmittedToReview" &&
          item.recipientID === sessionStorage.getItem("logedInUserName")
        ) {
          return true;
        }
        return false;
      });

      const tilesWithCounts = TILES.map(tile => {
        const match = filteredCounts.find((c: any) =>
          Number(c.tileId) === Number(tile.id)  // fixed type mismatch
        );

        return {
          ...tile,
          documentCount: match?.documentCount ?? 0
        };
      });

      if (this.canViewAllTiles) {
        this.tiles = this.filterByCategory(tilesWithCounts);
      } else {
        const storedTiles = JSON.parse(sessionStorage.getItem('userTiles') || '[]');
        const allowedTileIds = storedTiles.map((t: any) => Number(t.id));
        const filteredByUser = tilesWithCounts.filter(tile =>
          allowedTileIds.includes(Number(tile.id)) // FIX applied
        );
        this.tiles = this.filterByCategory(filteredByUser);
      }
    },

    error: err => console.error('Error loading counts:', err)
  });
}



  private filterByCategory(tiles: TileItem[]): TileItem[] {
    if (!this.categoryName) return tiles; // no category filter
    return tiles.filter(tile => tile.category === this.categoryName);
  }

  goToTileDetail(tile: TileItem) {
    this.selectedTile = tile;
    this.referenceService.setViewLabel(tile.viewLabel || 'VIEW');
    this.router.navigate([tile.viewLink], {
      relativeTo: this.route,
      queryParams: { categoryId: tile.id }
    });
  }

  get canViewAllTiles(): boolean {
    return (
      this.authenticationService.roles?.includes('SysAdmin',)
    );
  }

  public getUserTiles(): void {
    this.authHttpService.getUserInfo().subscribe({
      next: (result) => {
        if (result) {
          const userId = result.sub;

          this.authHttpService.getUserTiles(userId).subscribe({
            next: (tiles: any) => {
              this.assignedTiles = tiles;
            },
            error: (error) => {
              this.logService.error('Error fetching user tiles', error);
              this.loading = false;
            }
          });
        } else {
          this.logService.warn('User info not found.');
          this.loading = false;
        }
      },
      error: (error) => {
        this.logService.error('Error fetching user info', error);
        this.loading = false;
      }
    });
  }
  loadOrganisations(): void {
    let selectedOrg = localStorage.getItem('SelectedOrgId');
    this.userService.getOrganisations().subscribe({
      next: (response) => {
        this.userOrganisations = response.filter(x => x.id == selectedOrg);
        this.selectedOrgName = this.userOrganisations[0].organisationName;
      },
      error: (err) => console.error('Error loading organisations:', err)
    });
  }

}
